import script from "./closeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./closeIcon.vue?vue&type=script&setup=true&lang=js"

import "./closeIcon.vue?vue&type=style&index=0&id=6f903576&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f903576"]])

export default __exports__